<div class="row">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-body">

                <form [formGroup]="formSearch" (submit)="refresh()">
                    <div class="row"
                        *ngIf="currentUser.authorities.includes('ADMIN-DINAS') || currentUser.authorities.includes('SUDIN') || currentUser.authorities.includes('ADMIN')|| currentUser.authorities.includes('ADM_TA')|| currentUser.authorities.includes('AKUNTANSI-BPKD') || currentUser.authorities.includes('ADMIN-MONITORING')">
                        <div class="form-group col-2">
                            <small class="form-text text-muted">NPSN/Nama Sekolah</small>
                            <input type="text" class="form-control" id="kodeNama" name="kodeNama"
                                formControlName="kodeNama" placeholder="NPSN/Nama Sekolah">
                        </div>
                        <div class="form-group col-10 d-flex align-items-end">
                            <button type="submit" class="btn btn-secondary">
                                <i class="fa fa-search"></i> Cari
                            </button>
                        </div>
                    </div>
                </form>
                <hr>

                <div class="row">
                    <div class="col-12">
                        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                            class="row-border hover table table-bordered table-sm"></table>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<ngx-spinner></ngx-spinner>